import { render } from "./SkeletonBase.vue?vue&type=template&id=9c678356&scoped=true"
import script from "./SkeletonBase.vue?vue&type=script&lang=js"
export * from "./SkeletonBase.vue?vue&type=script&lang=js"

import "./SkeletonBase.vue?vue&type=style&index=0&id=9c678356&scoped=true&lang=css"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c678356"]])

export default __exports__